import { Button, makeStyles, TableCell, TableRow } from "@material-ui/core";
import React from "react";
import { NavLink } from "react-router-dom";
import { isCalibrationOperator } from "../../roles";

const useStyles = makeStyles((theme) => ({
  spacing: {
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(2),
    },
    boxShadow: "none",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(1),
  },
  actionButton: {
    width: "100%",
  },
}));

const PatientRow = ({
  patient,
  setOpenUserModal,
  setUserToEdit,
  setUserHandlerType,
  userRemoveHandler,
  grantCalibrationRoleHandler,
  calibrationOperatorsOnly = false,
}) => {
  const classes = useStyles();

  const { firstName, surname, mail, id } = patient;

  return (
    <TableRow>
      <TableCell>{firstName || "---"}</TableCell>
      <TableCell>{surname || "---"}</TableCell>
      <TableCell>{mail || "---"}</TableCell>

      <TableCell>
        <div className={classes.actions}>
          {patient.anonymizationRequestedAt && (
            <Button
              className={classes.actionButton}
              variant="contained"
              color="secondary"
              onClick={() => userRemoveHandler(id)}
            >
              Usuń
            </Button>
          )}
          {!calibrationOperatorsOnly && (
            <Button
              className={classes.actionButton}
              variant="contained"
              color="primary"
              disabled={isCalibrationOperator(patient)}
              onClick={() => grantCalibrationRoleHandler(id)}
            >
              {isCalibrationOperator(patient)
                ? "Kalibrator"
                : "Nadaj rolę kalibratora"}
            </Button>
          )}
        </div>
      </TableCell>
      {!calibrationOperatorsOnly && (
        <TableCell>
          <NavLink to={`/admin-panel/users/examinations-executed/user/${id}`}>
            <Button>Wykonane badania</Button>{" "}
          </NavLink>
        </TableCell>
      )}
    </TableRow>
  );
};

export default PatientRow;
